var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BoostPortalNavigationSteps } from '../enums/BoostPortalNavigationSteps';
import { BoostPortalBirthdayHelper } from '../helpers/BoostPortalBirthdayHelper';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { router } from '../router/BoostPortalRouter';
import { isErrorHTTP } from 'boost-api/APIRestClient';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { GenericReduxBindableMixin } from 'badphraim/redux/GenericReduxBindableMixin';
import { BoostPortalRootStore } from '../redux/BoostPortalRootStore';
import { BoostPortalStore } from '../redux/BoostPortalStore';
export class BoostSponsorController extends GenericReduxBindableMixin(class {
}, () => __awaiter(this, void 0, void 0, function* () { return BoostPortalRootStore.instance(); })) {
    constructor(host) {
        super();
        this.currentStep = BoostPortalNavigationSteps.DEPARTMENT;
        this.memberships = [];
        this.birthdayHelper = new BoostPortalBirthdayHelper();
        this.host = host;
        host.addController(this);
    }
    hostConnected() {
        //
    }
    setCurrentStep(step) {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentStep = step;
            this.currentStep = this._determineCurrentStep();
            if (this.currentStep === BoostPortalNavigationSteps.SPONSOR && this.memberHasInvalidContract) {
                yield this.activateMembershipForLoggedInUser();
            }
            this.host.requestUpdate();
        });
    }
    get memberHasInvalidContract() {
        return this.loggedInProfile && !this.loggedInProfile.contract_id && this.selectedMembershipId;
    }
    _determineCurrentStep() {
        if (!this.selectedDepartmentId || !this.selectedMembershipId) {
            return BoostPortalNavigationSteps.DEPARTMENT;
        }
        else if (!this._isValidCreatedMemberInformation() && !this.loggedInProfile) {
            return BoostPortalNavigationSteps.INFORMATION;
        }
        else if (this.memberCreated === 'true') {
            return BoostPortalNavigationSteps.SUCCESS;
        }
        return BoostPortalNavigationSteps.SPONSOR;
    }
    activateMembershipForLoggedInUser() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this.selectedMembershipId || !this.selectedDepartmentId || !((_a = this.loggedInProfile) === null || _a === void 0 ? void 0 : _a.memberid)) {
                return;
            }
            const activateMembershipForUserResult = yield MembersignupAPI.postV1BoostsignupMemberContractUsingMemberId(this.loggedInProfile.memberid, {
                departmentId: this.selectedDepartmentId,
                netsCallbackUrl: router.baseUrl +
                    this.centerShort +
                    '/avtalegiro' +
                    '?departmentId=' +
                    this.selectedDepartmentId,
                membershipId: this.selectedMembershipId,
                is_privately_sponsored: true,
            });
            if (isErrorHTTP(activateMembershipForUserResult)) {
                SnackBar.pushError(activateMembershipForUserResult.error);
                return;
            }
            this.loggedInProfile.contract_id = activateMembershipForUserResult.contractId;
            this.dispatch(BoostPortalStore.Actions.SetLoggedInProfile(this.loggedInProfile));
            this.host.requestUpdate();
        });
    }
    _isValidCreatedMemberInformation() {
        if (!this.memberInformation) {
            return false;
        }
        if (!this.memberInformation.departmentId ||
            !this.memberInformation.membershipId ||
            !this.memberInformation.contractId) {
            return false;
        }
        return true;
    }
    isValidMemberInformation() {
        if (!this.memberInformation) {
            return false;
        }
        if (!this.memberInformation.firstname ||
            !this.memberInformation.lastname ||
            !this.memberInformation.address ||
            !this.memberInformation.postal_code ||
            !this.memberInformation.municipality ||
            !this.memberInformation.phone_number ||
            !this.memberInformation.email ||
            !this.memberInformation.date_of_birth ||
            !this.memberInformation.gender ||
            !this.memberInformation.approve_tos) {
            return false;
        }
        return true;
    }
    setSelectedDepartmentId(departmentId) {
        if (!departmentId) {
            return;
        }
        this.selectedDepartmentId = departmentId;
        this.host.requestUpdate();
    }
    setSelectedMembershipId(membershipId) {
        if (!membershipId) {
            return;
        }
        this.selectedMembershipId = membershipId;
        this.host.requestUpdate();
    }
    setLoggedInProfile(profile) {
        if (!profile) {
            return;
        }
        this.loggedInProfile = profile;
        this.host.requestUpdate();
    }
    setSession(session) {
        if (!session) {
            return;
        }
        this.session = session;
        this.host.requestUpdate();
    }
    setCenter(center) {
        if (!center) {
            return;
        }
        this.center = center;
        this.host.requestUpdate();
    }
    setCenterShort(centerShort) {
        if (!centerShort) {
            return;
        }
        this.centerShort = centerShort;
        this.host.requestUpdate();
    }
    getSelectedMembership(selectMembershipId, memberships) {
        const membershipId = selectMembershipId || this.selectedMembershipId;
        if (!membershipId || !memberships) {
            return undefined;
        }
        return memberships.find((membership) => membership.id === membershipId);
    }
    selectedMembershipIsShortTerm(memberships) {
        const membership = this.getSelectedMembership(this.selectedMembershipId, memberships);
        if (!membership) {
            return false;
        }
        return membership.temporary;
    }
    setMemberships(memberships) {
        this.memberships = memberships;
        this.host.requestUpdate();
    }
    setMemberInformation(memberInformation) {
        if (!memberInformation) {
            return;
        }
        this.memberInformation = memberInformation;
        this.host.requestUpdate();
    }
    get isLoggedIn() {
        return this.session;
    }
    get loggedInProfileHasActiveMembership() {
        var _a;
        return (_a = this.loggedInProfile) === null || _a === void 0 ? void 0 : _a.memberid;
    }
    get isMemberUnderage() {
        var _a;
        const birthDate = (_a = this.loggedInProfile) === null || _a === void 0 ? void 0 : _a.birth;
        if (!birthDate) {
            return false;
        }
        return this.birthdayHelper.isMemberUnderage(birthDate);
    }
    get underageMemberMeetsShorttermRequirements() {
        var _a;
        const birthDate = (_a = this.loggedInProfile) === null || _a === void 0 ? void 0 : _a.birth;
        if (!birthDate || !this.center) {
            return false;
        }
        return this.birthdayHelper.memberMeetsShortTermMinimumAge(birthDate, this.center.short_term_minimum_age);
    }
    get redirectToMemberRoute() {
        var _a, _b;
        return (((_a = this.center) === null || _a === void 0 ? void 0 : _a.short_term_minimum_age) &&
            this.underageMemberMeetsShorttermRequirements &&
            ((_b = this.getSelectedMembership(this.selectedMembershipId, this.memberships)) === null || _b === void 0 ? void 0 : _b.temporary));
    }
}
